import { CONFIG_ELEMENTS } from '@vedalib/editor/lib/elements'

import { t } from 'services/Translation'

import { ElementGroup } from '../../elements.types'
import { genElementConfig } from '../../genElementConfig'
import RectangleDemo from './RectangleDemo'
import RectangleElement from './RectangleElement'
import RectangleFormBrand from './RectangleFormBrand'
import { STYLE_FORM_SCHEMA } from './RectangleFormStyle'
import rectangleIcon from './assets/rectangle.svg'

export default genElementConfig(CONFIG_ELEMENTS.rectangle, {
  label: t('elements.rectangle.label'),
  icon: rectangleIcon,
  group: ElementGroup.view,
  styleFields: STYLE_FORM_SCHEMA,
  Element: RectangleElement,
  Demo: [RectangleDemo],
  FormBrand: RectangleFormBrand,
  FormValue: null,
  EditorActions: null,
})
